<script setup lang="ts">
defineOptions({
  name: 'MopPageLoad',
});

defineProps({
  message: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="page-load">
    <div class="page-load__content">
      <i class="icon icon--loading-asset icon--page-load" />
      <span v-if="message" class="page-load__message" v-html="message" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-load {
  display: none;
}

.page-load__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(50vh - 200px) columns(2) 0 columns(2);
  transition: opacity 0.5s;
  opacity: 0;
  visibility: hidden;
}

.loading {
  @include z(global, abovecontent);

  display: block;
  position: absolute;
  background: $white;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .page-load__content {
    opacity: 1;
    visibility: visible;
  }
}

.enter {
  transition: all #{$transition-enter - 0.3s};
  opacity: 0;
  max-height: 0;
}

.page-load__message {
  @include text-style(running-bold);

  text-align: center;
  padding-top: $space30;
  animation: pulse 3s linear infinite;
}
</style>
